(function(){
if(window.__ffLoaded)return;window.__ffLoaded=true;
function arr(n){return Array.prototype.slice.call(n)}
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var CART_TRIGGERS='a[href$="/cart"],a[href*="/cart?"],cart-icon,cart-drawer-component>button,cart-drawer-component>summary,.header-actions__cart-icon,[data-ff-open-cart]';
var HDR={'Content-Type':'application/json','Accept':'application/json'};

/* ---------- Money ---------- */
var FMT=(document.documentElement.getAttribute('data-ff-money')||'{{amount_with_comma_separator}} €');
function money(c){
  var v=(c||0)/100,s;
  if(/no_decimals/.test(FMT))s=Math.round(v).toString();
  else s=v.toFixed(2);
  if(/comma_separator/.test(FMT)){s=s.replace('.',',');s=s.replace(/\B(?=(\d{3})+(?!\d))/g,'.')}
  else if(/apostrophe/.test(FMT)){s=s.replace(/\B(?=(\d{3})+(?!\d))/g,"'")}
  else{s=s.replace(/\B(?=(\d{3})+(?!\d))/g,',')}
  return FMT.replace(/\{\{\s*[a-z_]+\s*\}\}/,s);
}

/* ---------- Cart Drawer ---------- */
var C={el:null,loops:0,ploops:0,bound:false};
C.ready=function(){return !!C.el};
C.open=function(){if(!C.el)return;C.el.classList.add('open');document.documentElement.style.overflow='hidden'};
C.close=function(){if(!C.el)return;C.el.classList.remove('open');document.documentElement.style.overflow=''};
C.busy=function(b){if(C.el)C.el.classList.toggle('busy',!!b)};
C.bubble=function(n){
  arr(document.querySelectorAll('[data-ff-count]')).forEach(function(e){e.textContent=n});
  arr(document.querySelectorAll('cart-icon .cart-bubble__text-count,cart-icon [ref="cartBubbleCount"]')).forEach(function(e){e.textContent=n>0?n:''});
  arr(document.querySelectorAll('cart-icon .cart-bubble,cart-icon [ref="cartBubble"]')).forEach(function(e){e.classList.toggle('visually-hidden',!(n>0))});
};
C.render=function(html){
  if(!html||!C.el)return;
  var doc=new DOMParser().parseFromString(html,'text/html'),nb=doc.querySelector('[data-cart-body]'),ob=C.el.querySelector('[data-cart-body]');
  if(!nb||!ob)return;
  ob.innerHTML=nb.innerHTML;
  ['count','giftKey','giftQty','giftMax'].forEach(function(k){ob.dataset[k]=nb.dataset[k]||''});
  try{C.bubble(+ob.dataset.count)}catch(e){}
  C.fixGift(ob);
  if(!C.loops)C.autoProt();
};
C.fixGift=function(ob){
  if(!ob||!ob.dataset.giftKey)return;
  var have=+(ob.dataset.giftQty||0),max=+(ob.dataset.giftMax||0);
  if(have>max){if(C.loops>2)return;C.loops++;C.change(ob.dataset.giftKey,max)}else{C.loops=0}
};
/* Versandschutz: vorausgewählt, solange der Kunde ihn nicht abwählt; fällt raus, wenn sonst nichts im Warenkorb ist */
C.protOff=function(v){try{if(v===undefined)return sessionStorage.getItem('ff_noprot')==='1';if(v)sessionStorage.setItem('ff_noprot','1');else sessionStorage.removeItem('ff_noprot')}catch(e){return false}};
C.autoProt=function(){
  var el=C.el;if(!el)return;
  var ob=el.querySelector('[data-cart-body]'),p=ob&&ob.querySelector('[data-protect]');if(!p)return;
  var n=+(ob.dataset.count||0);
  if(n===0&&p.checked&&p.dataset.key){if(C.ploops>2)return;C.ploops++;C.change(p.dataset.key,0);return}
  if(el.dataset.protPre==='true'&&n>0&&!p.checked&&!C.protOff()){if(C.ploops>2)return;C.ploops++;C.req('cart/add.js',{items:[{id:+p.dataset.protect,quantity:1}]});return}
  C.ploops=0;
};
C.sec=function(){return C.el?C.el.dataset.section:''};
C.req=function(path,body){
  var id=C.sec();C.busy(true);
  body.sections=id;body.sections_url=location.pathname;
  return fetch(root+path,{method:'POST',headers:HDR,body:JSON.stringify(body)})
    .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
    .then(function(res){C.busy(false);if(!res.ok){alert(res.j.description||res.j.message||'Fehler');return C.refresh()}C.render(res.j.sections&&res.j.sections[id])})
    .catch(function(){C.busy(false)});
};
C.add=function(items){return C.req('cart/add.js',{items:items}).then(C.open)};
C.change=function(key,qty){return C.req('cart/change.js',{id:key,quantity:qty})};
C.refresh=function(){
  var id=C.sec();if(!id)return Promise.resolve();
  return fetch(location.pathname+'?sections='+encodeURIComponent(id)).then(function(r){return r.json()}).then(function(j){C.render(j[id])}).catch(function(){});
};
C.switchAbo=function(el){
  var vid=el.dataset.variant,sp=el.dataset.sp,key=el.dataset.key,qty=+(el.dataset.qty||1),toAbo=el.checked,sid=C.sec();
  C.busy(true);
  fetch(root+'cart/change.js',{method:'POST',headers:HDR,body:JSON.stringify({id:''+key,quantity:0})})
    .then(function(r){if(!r.ok)throw new Error('remove failed');return r.json()})
    .then(function(){
      var item={id:+vid,quantity:qty};
      if(toAbo&&sp)item.selling_plan=+sp;
      return fetch(root+'cart/add.js',{method:'POST',headers:HDR,body:JSON.stringify({items:[item],sections:sid,sections_url:location.pathname})});
    })
    .then(function(r){if(!r.ok)throw new Error('add failed');return r.json()})
    .then(function(j){C.busy(false);if(j.sections&&j.sections[sid])C.render(j.sections[sid]);else C.refresh()})
    .catch(function(){C.busy(false);C.refresh()});
};
function cart(el){
  if(el.dataset.ffReady)return;el.dataset.ffReady='1';
  var wasOpen=false;
  if(C.el&&C.el!==el){wasOpen=C.el.classList.contains('open');C.el.remove()}
  C.el=el;
  if(el.parentNode!==document.body)document.body.appendChild(el);
  if(wasOpen)el.classList.add('open');
  el.addEventListener('click',function(e){
    var t=e.target.closest('[data-cart-close]');if(t){C.close();return}
    t=e.target.closest('[data-key][data-qty]:not([data-abo-switch])');if(t){e.preventDefault();C.change(t.dataset.key,+t.dataset.qty);return}
    t=e.target.closest('[data-add]');if(t){e.preventDefault();C.add([{id:+t.dataset.add,quantity:1}])}
  });
  el.addEventListener('change',function(e){
    var t=e.target;
    if(t.hasAttribute('data-protect')){
      C.protOff(!t.checked);
      if(t.checked){C.req('cart/add.js',{items:[{id:+t.dataset.protect,quantity:1}]})}else if(t.dataset.key){C.change(t.dataset.key,0)}
      return;
    }
    if(t.hasAttribute('data-abo-switch')){C.switchAbo(t);return}
  });
  if(!C.bound){
    C.bound=true;
    document.addEventListener('keydown',function(e){if(e.key==='Escape')C.close()});
    document.addEventListener('click',function(e){
      if(!C.el||C.el.dataset.intercept!=='true'||C.el.contains(e.target))return;
      var t=e.target.closest(CART_TRIGGERS);if(!t)return;
      if(t.closest('dialog,[role="dialog"]'))return;
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
      C.refresh().then(C.open);
    },true);
  }
  try{C.bubble(+el.querySelector('[data-cart-body]').dataset.count)}catch(e){}
  C.fixGift(el.querySelector('[data-cart-body]'));
  if(!C.loops)C.autoProt();
}
window.FFCart=C;

/* ---------- Hero: Galerie + Kaufbox ---------- */
function hero(s){
  if(s.dataset.ffReady)return;s.dataset.ffReady='1';
  var $=function(q){return s.querySelector(q)},$$=function(q){return arr(s.querySelectorAll(q))};

  /* Galerie */
  var track=$('[data-track]'),thumbs=$$('[data-thumb]'),tc=$('[data-thumbs]'),count=$('[data-count]'),cur=0;
  if(track){
    var n=track.children.length;
    var mark=function(i){cur=i;thumbs.forEach(function(t,k){t.classList.toggle('on',k===i)});if(count)count.textContent=(i+1)+' / '+n;var t=thumbs[i];if(t&&tc)tc.scrollTo({left:t.offsetLeft-tc.clientWidth/2+t.clientWidth/2,behavior:'smooth'})};
    var go=function(i){i=(i+n)%n;track.scrollTo({left:i*track.clientWidth,behavior:'smooth'})};
    var raf;track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){var i=Math.round(track.scrollLeft/track.clientWidth);if(i!==cur)mark(i)})},{passive:true});
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k)})});
    var p=$('[data-prev]'),x=$('[data-next]');if(p)p.addEventListener('click',function(){go(cur-1)});if(x)x.addEventListener('click',function(){go(cur+1)});
  }

  /* Kaufbox */
  var atc=$('[data-atc]'),vars=$$('input[name="id"]'),modes=$$('input[name="ff_mode"]'),aboToggle=$('[data-abo-toggle]'),aboCard=$('.ff-abo-card,.ff-abo-box');
  var out={aboP:$('[data-abo-price]'),aboCap:$('[data-abo-cap]'),oncP:$('[data-once-price]'),oncCap:$('[data-once-cap]'),infoA:$('.ff-vinfo [data-info-a]'),infoB:$('.ff-vinfo [data-info-b]'),refills:$$('[data-refills]'),stickyP:$$('[data-sticky-price]'),aboPer:$('[data-abo-per]')};
  var v=function(){return vars.filter(function(e){return e.checked})[0]||vars.filter(function(e){return !e.disabled})[0]};
  var mode=function(){var m=modes.filter(function(e){return e.checked})[0];return m?m.value:'once'};
  var set=function(el,t){if(el)el.textContent=t};
  var getPlan=function(r){var plans;try{plans=JSON.parse(r.dataset.plans||'{}')}catch(e){plans={}}var keys=Object.keys(plans);if(!keys.length)return null;var planEl=$('[data-plan]');var pid=planEl?planEl.value:'';return pid&&plans[pid]?{id:pid,price:plans[pid]}:{id:keys[0],price:plans[keys[0]]}};
  var sync=function(){
    var r=v();if(!r)return;
    if(!r.checked)r.checked=true;
    var price=+r.dataset.price,cap=+(r.dataset.cap||0);
    var refills=+(r.dataset.refills||1);
    var pl=getPlan(r);
    var aboP=pl?pl.price:null;
    var isAbo=mode()==='abo'&&!!aboP;
    set(out.oncP,money(price));
    if(out.oncCap){out.oncCap.textContent=cap>price?money(cap):'';out.oncCap.style.display=cap>price?'':'none'}
    if(aboP){set(out.aboP,money(aboP));if(out.aboCap){var ac=cap>price?cap:price;out.aboCap.textContent=money(ac);out.aboCap.style.display=aboP<ac?'':'none'}}
    set(out.infoA,r.dataset.infoA||'');set(out.infoB,r.dataset.infoB||'');
    out.refills.forEach(function(e){e.textContent=r.dataset.refills||''});
    $$('.ff-m-gift [data-gift-label]').forEach(function(e){e.textContent=r.dataset.giftLabel||''});
    var ab=$('input[name="ff_mode"][value="abo"]');
    if(ab){
      if(aboCard)aboCard.classList.toggle('ff-hide',!aboP);
      if(!aboP&&ab.checked){var on=$('input[name="ff_mode"][value="once"]');if(on)on.checked=true;isAbo=false}
      if(aboToggle)aboToggle.checked=ab.checked;
    }
    var ok=r.dataset.available==='true';
    if(atc){atc.disabled=!ok;var lab=atc.querySelector('[data-atc-label]'),pr=atc.querySelector('[data-atc-price]');if(lab)lab.textContent=ok?atc.dataset.label:atc.dataset.soldout;if(pr)pr.textContent=ok?(' · '+money(isAbo?aboP:price)):''}
    out.stickyP.forEach(function(e){e.textContent=money(isAbo?aboP:price)});
    $$('[data-sticky-sel]').forEach(function(e){e.textContent=(r.dataset.giftLabel||'')+(isAbo?' im Abo':'')});
  };
  vars.forEach(function(r){r.addEventListener('change',sync)});
  modes.forEach(function(r){r.addEventListener('change',sync)});
  if(aboToggle)aboToggle.addEventListener('change',function(){
    var want=aboToggle.checked?'abo':'once';
    modes.forEach(function(r){r.checked=(r.value===want)});
    sync();
  });
  sync();

  var form=$('form.ff-form');
  if(form)form.addEventListener('submit',function(e){
    if(!C.ready()||form.querySelector('[name=return_to]'))return;
    e.preventDefault();
    var r=v();if(!r)return;
    var pl=getPlan(r);
    var isAbo=mode()==='abo'&&!!pl;
    var item={id:+r.value,quantity:1};
    if(isAbo)item.selling_plan=+pl.id;
    var items=[item];
    var gv=form.dataset.giftVariant,gq=+(r.dataset.giftQty||0);
    if(isAbo&&r.dataset.aboVariant&&r.dataset.aboVariant!==r.value){item.id=+r.dataset.aboVariant;if(gv&&gq>0)items.push({id:+gv,quantity:gq,properties:{_gift:'1'}})}
    if(atc)atc.disabled=true;
    C.add(items).then(function(){if(atc)atc.disabled=false},function(){if(atc)atc.disabled=false});
  });
  var st=$('[data-sticky]');
  if(st&&atc){
    var sb=st.querySelector('[data-sticky-atc]');
    if(sb)sb.addEventListener('click',function(){if(atc.disabled)return;atc.click()});
    if('IntersectionObserver' in window){new IntersectionObserver(function(en){var e=en[0];var mob=window.matchMedia&&matchMedia('(max-width:749px)').matches;var past=!e.isIntersecting&&(mob||e.boundingClientRect.top<0);st.classList.toggle('show',past);document.body.classList.toggle('ff-sticky-on',past&&mob);st.setAttribute('aria-hidden',past?'false':'true')},{rootMargin:'-80px 0px 0px 0px'}).observe(atc)}
  }
}

/* ---------- Video-Karten (Social) ---------- */
function social(s){
  if(s.dataset.ffReady)return;s.dataset.ffReady='1';
  arr(s.querySelectorAll('[data-video]')).forEach(function(w){
    var vid=w.querySelector('video');if(!vid)return;
    w.addEventListener('click',function(){if(vid.paused){vid.play();w.classList.add('playing')}else{vid.pause();w.classList.remove('playing')}});
  });
}

function all(){
  arr(document.querySelectorAll('[data-ff-cart]')).forEach(cart);
  arr(document.querySelectorAll('[data-ff-hero]')).forEach(hero);
  arr(document.querySelectorAll('[data-ff-social]')).forEach(social);
}
if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
document.addEventListener('shopify:section:load',all);
document.addEventListener('shopify:section:select',function(e){if(C.el&&e.detail&&e.detail.sectionId===C.el.dataset.section)C.open()});
document.addEventListener('shopify:section:deselect',function(e){if(C.el&&e.detail&&e.detail.sectionId===C.el.dataset.section)C.close()});
})();
